import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TicketModel } from 'src/app/shared/models/domain/ticket.model';

@Injectable()
export class TicketService {
  private url = environment.apiUrl + '/tickets/';

  constructor(private http: HttpClient) {
  }

  create(model: TicketModel): Observable<string> {
    return this.http.post<string>(`${this.url}`, model)
  }
}
